import { access, integrationStatus } from '@driftt/traffic-control'

export const HubspotAccessTypes = {
  HAS_ACCESS_NOT_CONNECTED: 'HAS_ACCESS_NOT_CONNECTED',
  HAS_ACCESS_CONNECTED: 'HAS_ACCESS_CONNECTED',
  NO_ACCESS_HIDDEN: 'NO_ACCESS_HIDDEN',
}

const hasGate = (gate) => {
  return access.hasGates(gate)
}

const isEmailBotsCustomer = () => {
  return hasGate('has_siftrock_bots_v2') || hasGate('has_siftrock_bots_v2_existing_org')
}

export const shouldShowHubspotImports = () => {
  return isEmailBotsCustomer()
}

export const getOrgHubspotAccessType = () => {
  const hasAccess = shouldShowHubspotImports()
  const hubspotIsConnected = integrationStatus.isIntegrationConnected('hubspot')

  if (hasAccess && hubspotIsConnected) {
    return HubspotAccessTypes.HAS_ACCESS_CONNECTED
  }

  if (hasAccess && !hubspotIsConnected) {
    return HubspotAccessTypes.HAS_ACCESS_NOT_CONNECTED
  }

  return HubspotAccessTypes.NO_ACCESS_HIDDEN
}
